export default "__VITE_ASSET__c716a6ba__"